import type { MotionNodeAnimationOptions, Transition } from 'motion/react';

export const popoverConfig = (offset: number[] = [0, 10], overflowPadding: number = 0) => ({
  modifiers: [
    {
      name: 'offset',
      options: {
        offset,
      },
    },
    {
      name: 'preventOverflow',
      options: {
        padding: overflowPadding,
        boundariesElement: 'window',
      },
    },
    {
      name: 'computeStyles',
      options: {
        gpuAcceleration: false,
      },
    },
  ],
});

export const animateOpacity = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
    transition: {
      delay: 0.25,
    },
  },
};

export const animateScaleAndOpacity: MotionNodeAnimationOptions = {
  initial: { scale: 0, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0, opacity: 0 },
  transition: { duration: 0.1, ease: 'easeOut' },
};

/** Shared emphasized-ease curve for surfaces that move, open or resize. */
export const emphasizedTransition = {
  duration: 0.22,
  ease: [0.22, 1, 0.36, 1],
} satisfies Transition;

export const tagDefaultColor = '#246bfd';
export const tagColorBlue = tagDefaultColor;
export const tagColorGreen = '#52C41A';
export const tagColorPurple = '#722ED1';
export const tagColorOrange = '#FA8C16';

export const recommendedColorSet = [
  '#F5222D',
  tagColorOrange,
  '#FADB14',
  '#8BBB11',
  tagColorGreen,
  '#13A8A8',
  tagColorBlue,
  '#2F54EB',
  tagColorPurple,
  '#EB2F96',
];
